import { render, staticRenderFns } from "./TeacherCardNextLabel.vue?vue&type=template&id=456e3db6&scoped=true&"
import script from "./TeacherCardNextLabel.vue?vue&type=script&lang=js&"
export * from "./TeacherCardNextLabel.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCardNextLabel.vue?vue&type=style&index=0&id=456e3db6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456e3db6",
  null
  
)

export default component.exports